<div #dropdown="ngbDropdown"
     ngbDropdown
     container="body"
     display="dynamic"
     placement="bottom-end">
  <button ngbDropdownToggle
          type="button"
          class="btn btn-dark">
    VO
  </button>
  <ul ngbDropdownMenu class="dropdown-menu-dark px-3 py-2">
    <h6>
      <i class="fa-light fa-planet-ringed me-1"></i>Observatory
    </h6>
    <li *ngFor="let voServiceItem of voServiceItems"
        class="list-group-item d-flex justify-content-between align-items-center">
      <ng-container *ngIf="voServiceItem?.instruments">
        <div ngbDropdown class="w-100 my-1">
          <button type="button" class="btn btn-sm btn-dark w-100" ngbDropdownToggle>
            {{voServiceItem.name}}
          </button>
          <ul ngbDropdownMenu class="dropdown-menu-dark px-3 py-2 overflow-auto bg-opacity-50" style="max-height: 40vh">
            <h6 class="text-nowrap">
              <i class="fa-light fa-telescope me-1"></i>{{voServiceItem.name}} Instrument
            </h6>
            <li *ngFor="let instrument of voServiceItem.instruments"
                class="list-group-item d-flex justify-content-between align-items-center">
              <button type="button"
                      class="btn btn-sm btn-dark w-100 my-1"
                      (click)="emitAddVoServiceInstrumentItem(instrument, voServiceItem)">
                {{instrument}}
              </button>
            </li>
          </ul>
        </div>
      </ng-container>
      <ng-container *ngIf="!voServiceItem?.instruments">
        <button class="btn btn-sm btn-dark w-100 my-1"
                (click)="emitAddVoServiceItem(voServiceItem)">
          {{voServiceItem.name}}
        </button>
      </ng-container>
    </li>
    <li *ngIf="voServicesOverlays?.length > 0">
      <hr class="dropdown-divider border-white">
    </li>
    <li *ngFor="let voService of voServicesOverlays"
        class="list-group-item d-flex justify-content-between align-items-center my-1">
      <div class="text-white">
        <i class="fa-solid fa-circle me-1" [style.color]="voService.color"></i>
        {{voService.name}}
      </div>
      <button class="btn btn-sm btn-dark"
              (click)="emitRemoveVoServiceOverlay(voService.id)">
        <i class="fa-light fa-xmark"></i>
      </button>
    </li>
  </ul>
</div>
